
import {
    Box,
    IconButton,
    Paper,
    Typography
} from "@mui/material";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const PreferenceCard = ({
    item,
    onDelete,
    isEditing
}) => {

    const sortable = useSortable({
        id: item.id,
        disabled: !isEditing
    });

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({
        id: item.id
    });


    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        touchAction: "none"
    };


    return (
        <div
            ref={setNodeRef}
            style={style}
        >

            <Paper
                elevation={isDragging ? 4 : 0}
                sx={{
                    p: 2,
                    // mb: 0.5,
                    border: "1px solid #e5e7eb",
                    borderRadius: 2,
                    background: "#fff",
                    opacity: isDragging ? 0.7 : 1
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}
                >

                    {/* LEFT SECTION */}

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5
                        }}
                    >

                        <Typography
                            sx={{
                                width: 30,
                                height: 30,
                                borderRadius: "50%",
                                background: "#f3f4f6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 600
                            }}
                        >
                            {item.position}
                        </Typography>

                        <Box>

                            <Typography fontWeight={600} sx={{ textAlign: 'left' }}>
                                {item.college}
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ textAlign: "left" }}
                            >
                                {item.branch}
                            </Typography>

                        </Box>

                    </Box>

                    {/* ACTIONS */}

                    {isEditing && (

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center"
                            }}
                        >

                            {/* DELETE */}

                            <IconButton
                                color="error"
                                onClick={() => onDelete(item.id)}
                            >
                                <DeleteOutlineIcon />
                            </IconButton>

                            {/* DRAG */}

                            <IconButton
                                {...attributes}
                                {...listeners}
                                sx={{
                                    cursor: "grab"
                                }}
                            >
                                <DragIndicatorIcon />
                            </IconButton>

                        </Box>
                    )}

                </Box>


            </Paper>

        </div>
    );
};

export default PreferenceCard;